/*
 * sp-reveal.js
 * Adds .is-in to every .sp-reveal element the first time it enters the
 * viewport (once). The initial hidden state and the transition live in
 * assets/serpentina-brand.css. No dependencies.
 *
 * Public hooks:
 *   .sp-reveal                  element to reveal
 *   .is-in                      added once, never removed
 *   data-sp-reveal-delay="200"  optional transition delay in ms
 * Re-scans on the theme editor event shopify:section:load, so sections
 * added in the editor still reveal.
 */
(function () {
  'use strict';

  // Hands control from the CSS 4s fail-safe to the observer.
  document.documentElement.classList.add('sp-reveal-ready');

  var SELECTOR = '.sp-reveal:not(.is-in)';
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reduced motion: CSS already shows everything, so there is nothing to do.
  if (reduceMotion) return;

  var observer = null;

  function reveal(el) {
    el.classList.add('is-in');
  }

  function onIntersect(entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      obs.unobserve(entry.target);
    });
  }

  function observe(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    // No IntersectionObserver: show everything immediately.
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, reveal);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(onIntersect, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      });
    }

    Array.prototype.forEach.call(nodes, function (el) {
      var delay = el.getAttribute('data-sp-reveal-delay');
      if (delay) el.style.transitionDelay = parseInt(delay, 10) + 'ms';
      observer.observe(el);
    });
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });
})();
